// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2XHXN","errors":"Errors_errors__30Szs"};